import { FC } from 'react';
import { ActionModal, ModalActionProps } from '../../UI';
import { Business } from '../../generated/graphql';
import { useBusinessForm } from '../hooks';
import { useUpdateBusinessService } from '../service';
import { updateBusinessServiceInputFromForm } from '../util';
import { BusinessForm } from './BusinessForm';
import { BusinessEstimatedValueInput } from './BusinessEstimatedValueInput';
import { getTotalOwnershipPercentage } from '../../Owner';
import { useTranslation } from 'react-i18next';

export type EditBusinessValueModalFormProps = Pick<ModalActionProps, 'onCancel' | 'onSave' | 'isLoading'> & {
  business: Business;
  afterUpdate?: (business: Business) => Promise<void>;
};

export const EditBusinessValueModalForm: FC<EditBusinessValueModalFormProps> = ({
  business,
  onCancel,
  onSave,
  isLoading: isLoadingExternal,
  afterUpdate,
}) => {
  const { updateBusinessService } = useUpdateBusinessService();
  const { t: tForm } = useTranslation('form');
  const helperText =
    getTotalOwnershipPercentage(business.ownership) !== 1
      ? tForm('general-partial-ownership-discount-helper-text')
      : undefined;

  const useBusinessFormReturn = useBusinessForm({
    businessID: business.id,
    householdID: business.householdID,
    handleSubmit: async (data) => {
      await updateBusinessService.mutateAsync(updateBusinessServiceInputFromForm(data));
      await afterUpdate?.(business);
    },
  });

  return (
    <ActionModal title={business.name}>
      {(action) => (
        <BusinessForm useBusinessFormReturn={useBusinessFormReturn} className="grid grid-cols-1 gap-2">
          <BusinessEstimatedValueInput autoFocus={true} helperText={helperText} />
          {action({
            onSave: onSave,
            onCancel: onCancel,
            isLoading: updateBusinessService.isLoading || isLoadingExternal,
          })}
        </BusinessForm>
      )}
    </ActionModal>
  );
};
